import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const RECENT_PURCHASES = [{
  name: 'Mariela',
  city: 'Rosario',
  product: 'Megapack Bolsos Crochet Pro'
}, {
  name: 'Laura',
  city: 'Córdoba',
  product: 'Megapack Bolsos Crochet Pro'
}, {
  name: 'Verónica',
  city: 'Mendoza',
  product: 'Megapack Bolsos Crochet Pro'
}];
const VISIBLE_DURATION = 10000;
const HIDDEN_DURATION = 30000;
export function SocialProofToast() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return undefined;
    const timer = window.setTimeout(() => {
      if (isVisible) {
        setIsVisible(false);
        return;
      }
      setActiveIndex(current => (current + 1) % RECENT_PURCHASES.length);
      setIsVisible(true);
    }, isVisible ? VISIBLE_DURATION : HIDDEN_DURATION);
    return () => window.clearTimeout(timer);
  }, [isDismissed, isVisible]);
  if (isDismissed || !isVisible) return null;
  const purchase = RECENT_PURCHASES[activeIndex];
  return <aside key={`${purchase.name}-${purchase.city}`} className="social-proof-enter fixed bottom-3 left-3 right-3 z-50 flex max-w-sm items-start gap-3 rounded-2xl border border-sand-line bg-cream-card p-3.5 shadow-[0_14px_34px_rgba(58,41,32,0.18)] sm:bottom-6 sm:left-6 sm:right-auto sm:p-4" aria-live="polite" aria-label="Compra reciente" data-id="element-316" data-mp="kd2h7nr0uhep">
      <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-terra-soft text-terra" data-id="element-317" data-mp="13besbf1hu1cx">
        <ShoppingBagIcon className="h-5 w-5" aria-hidden="true" data-id="element-318" data-mp="181lgxew09lv6" />
      </span>
      <div className="min-w-0 flex-1 pr-1" data-id="element-319" data-mp="1d182cblzm8f2">
        <p className="text-[10px] font-extrabold uppercase tracking-[0.16em] text-terra" data-id="element-320" data-mp="1czwotk2qpmar">Compra reciente</p>
        <p className="mt-0.5 text-sm font-bold text-cocoa" data-id="element-321" data-mp="1i1vtcxa7up9a">
          {purchase.name} de {purchase.city}
        </p>
        <p className="mt-0.5 text-xs leading-snug text-cocoa-dim" data-id="element-322" data-mp="1m261afhkjpqs">Eligió {purchase.product} · acceso inmediato</p>
      </div>
      <button type="button" onClick={() => setIsDismissed(true)} className="-m-1.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full text-cocoa-dim transition-colors duration-150 hover:text-cocoa focus:outline-none focus-visible:ring-2 focus-visible:ring-terra" aria-label="Cerrar notificación" data-id="element-323" data-mp="3e3fq8nb0hmlg">
        <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-324" data-mp="5n4f1g9o24yl" />
      </button>
    </aside>;
}